 <desktop-header [displayBanner]="true" (languageChanged)="updateTextAndErrorMessages($event)" [selectedTab]="selectedTab"></desktop-header>
<mobile-header [displayBanner]="true" (languageChanged)="updateTextAndErrorMessages($event)"></mobile-header>
